import { toast } from "sonner";
import { api, errMsg, splitName } from "../lib/api";
import { useAuth } from "../lib/auth";
import { RecordDialog } from "./RecordDialog";
import { useOrgLists, orgField } from "./OrgLists";

export function ProfileDialog({ onClose }) {
  const { user, account } = useAuth();
  const org = useOrgLists();
  const admin = user.role === "agency_owner" || user.role === "subaccount_admin";
  const canEmail = user.role === "agency_owner" || [account?.owner_user_id, account?.admin_user_id].includes(user.id)
    || (user.role === "subaccount_admin" && !account?.owner_user_id && !account?.admin_user_id);
  const ro = admin ? {} : { type: "readonly" };
  const note = admin ? "" : " (set by Administration)";
  return (
    <RecordDialog open onOpenChange={(o) => !o && onClose()} title="My profile"
      initial={{ ...splitName(user.name), phone: user.phone || "", email: user.email, division: user.division || "", position: user.position || "" }}
      fields={[{ key: "first_name", label: "First name", required: true }, { key: "last_name", label: "Last name" }, { key: "phone", label: "Mobile for SMS security codes (e.g. +61400000000)", full: true },
        canEmail ? { key: "email", label: "Email (used to sign in)", full: true } : { key: "email", label: "Email (set by Administration)", type: "readonly", full: true },
        ...(canEmail ? [{ key: "email_password", label: "Current password (only needed if you change your email)", type: "password", full: true }] : []),
        user.role === "agency_owner" ? null : admin ? orgField("division", "Division", org.divisions) : { key: "division", label: `Division${note}`, ...ro },
        admin ? orgField("position", "Position", org.positions) : { key: "position", label: `Position${note}`, ...ro }].filter(Boolean)}
      onSave={async (f) => {
        const name = [f.first_name, f.last_name].map((x) => (x || "").trim()).filter(Boolean).join(" ");
        const body = admin ? { name, phone: f.phone, division: f.division || "", position: f.position || "" } : { name, phone: f.phone };
        try {
          if (canEmail && f.email && f.email.trim().toLowerCase() !== user.email) {
            if (!f.email_password) { toast.error("Enter your current password to change your email"); throw new Error("v"); }
            await api.post("/auth/change-email", { new_email: f.email.trim(), password: f.email_password });
          }
          await api.put("/auth/profile", body); toast.success("Profile saved"); window.location.reload();
        } catch (e) { if (e.message !== "v") toast.error(errMsg(e)); throw e; }
      }} />
  );
}

export function PasswordDialog({ onClose }) {
  return (
    <RecordDialog open onOpenChange={(o) => !o && onClose()} title="Change password" initial={{}}
      fields={[{ key: "current_password", label: "Current password", type: "password", required: true, full: true }, { key: "new_password", label: "New password (min 8 characters)", type: "password", required: true, full: true }, { key: "confirm_password", label: "Confirm new password", type: "password", required: true, full: true }]}
      onSave={async (f) => {
        toast.dismiss();
        if ((f.new_password || "").length < 8) { toast.error("New password must be at least 8 characters"); throw new Error("v"); }
        if (f.new_password !== f.confirm_password) { toast.error("New passwords do not match"); throw new Error("v"); }
        try { await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); toast.success("Password changed. Use your new password next time you sign in."); onClose(); }
        catch (e) { toast.error(errMsg(e)); throw e; }
      }} />
  );
}
